import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-403">
      <div className="max-w-5xl mx-auto" data-id="element-404">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-405">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-406">
            La solución:{' '}
            <span className="text-blue-600" data-id="element-407">Todo listo para usar</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-408">
            12 módulos completos que cubren todo el programa de Teoría de las
            Organizaciones. Con actividades, evaluaciones y material de apoyo.
          </p>
        </div>

        {/* Distribution Box */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 md:p-10 mb-8 border border-blue-200" data-id="element-409">
          <div className="flex items-start gap-3 mb-4" data-id="element-410">
            <span className="text-2xl" data-id="element-411">📍</span>
            <div data-id="element-412">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-413">
                Distribución sugerida:
              </h3>
              <div className="space-y-3" data-id="element-414">
                <div className="flex items-center gap-3" data-id="element-415">
                  <div className="bg-blue-600 text-white px-3 py-1.5 rounded-lg font-bold text-sm min-w-[120px] text-center" data-id="element-416">
                    1° Trimestre
                  </div>
                  <div className="text-gray-700 font-semibold text-sm" data-id="element-417">
                    Módulos 1 a 4
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-418">
                  <div className="bg-blue-600 text-white px-3 py-1.5 rounded-lg font-bold text-sm min-w-[120px] text-center" data-id="element-419">
                    2° Trimestre
                  </div>
                  <div className="text-gray-700 font-semibold text-sm" data-id="element-420">
                    Módulos 5 a 8
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-421">
                  <div className="bg-blue-600 text-white px-3 py-1.5 rounded-lg font-bold text-sm min-w-[120px] text-center" data-id="element-422">
                    3° Trimestre
                  </div>
                  <div className="text-gray-700 font-semibold text-sm" data-id="element-423">
                    Módulos 9 a 12
                  </div>
                </div>
              </div>
              <p className="text-gray-700 mt-4 text-base" data-id="element-424">
                Todo pensado para que el año tenga orden, coherencia y
                continuidad.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-4" data-id="element-425">
          <div className="flex gap-3 items-start bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-426">
            <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-427" />
            <div data-id="element-428">
              <h4 className="font-bold text-gray-900 mb-1 text-sm" data-id="element-429">
                Clases estructuradas
              </h4>
              <p className="text-gray-600 text-sm" data-id="element-430">
                Cada módulo con objetivos, contenidos y actividades claras
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-start bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-431">
            <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-432" />
            <div data-id="element-433">
              <h4 className="font-bold text-gray-900 mb-1 text-sm" data-id="element-434">
                Evaluaciones listas
              </h4>
              <p className="text-gray-600 text-sm" data-id="element-435">
                Con rúbricas y criterios de corrección definidos
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-start bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-436">
            <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-437" />
            <div data-id="element-438">
              <h4 className="font-bold text-gray-900 mb-1 text-sm" data-id="element-439">
                Material de apoyo
              </h4>
              <p className="text-gray-600 text-sm" data-id="element-440">
                Presentaciones, guías y recursos complementarios
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-start bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-441">
            <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-442" />
            <div data-id="element-443">
              <h4 className="font-bold text-gray-900 mb-1 text-sm" data-id="element-444">
                Adaptable a tu estilo
              </h4>
              <p className="text-gray-600 text-sm" data-id="element-445">
                Podés usar todo tal cual o personalizarlo según tu grupo
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}